import React from "react";
import "./style.css";
import { formateDateAndTime } from "../../../../../helper";
import { useSelector } from "react-redux";

const CaseReport = ({ caseDetails, isDirty = false }) => {
  const { dropdowns, countriesList = [] } = useSelector(
    (state) => state.general
  );

  const countryName = countriesList?.find(
    (con) => con.id === caseDetails?.nationality
  )?.name;
  const ethnicityName = dropdowns?.ethnicity?.find(
    (et) => et.id === caseDetails?.ethnicity
  )?.value;
  const status = dropdowns?.status?.find(
    (et) => et.id === caseDetails?.status
  )?.value;
  const gender = dropdowns?.gender?.find(
    (et) => et.id === caseDetails?.gender
  )?.value;

  let bmiValue = "Unknown";
  if (caseDetails?.height && caseDetails?.weight) {
    bmiValue = `${caseDetails?.bmi?.bmi}, ${caseDetails?.bmi?.range} (${caseDetails?.bmi?.age_range})`;
  }

  const subjectInformation = [
    { id: 1, key: "Name", value: caseDetails?.full_name },
    {
      id: 2,
      key: "Nationality",
      value: isDirty ? countryName : caseDetails?.nationality || "Unknown",
    },
    {
      id: 3,
      key: "DOB",
      value:
        formateDateAndTime(
          isDirty ? caseDetails?.reported_dob : caseDetails?.date,
          "DD MMM YYYY"
        ) || "Unknown",
    },
    {
      id: 334,
      key: "Biological Sex",
      value: isDirty ? gender : caseDetails?.gender || "Unknown",
    },
    {
      id: 4,
      key: "Status",
      value: isDirty ? status : caseDetails?.subject_status || "Unknown",
    },
    {
      id: 5,
      key: "Ancestry",
      value: isDirty ? ethnicityName : caseDetails?.ethnicity || "Unknown",
    },
    { id: 6, key: "Height (cm)", value: caseDetails?.height || "Unknown" },
    { id: 7, key: "Weight (kg)", value: caseDetails?.weight || "Unknown" },
    { id: 71, key: "BMI", value: !isDirty ? bmiValue : "Unknown" },
    {
      id: 8,
      key: "Medical History",
      value: caseDetails?.medical_history || "Unknown",
    },
    {
      id: 122,
      key: "Bone & Dental Health",
      value: caseDetails?.bone_assessment || "Unknown",
    },
    {
      id: 9,
      key: "Identity Type",
      value: caseDetails?.identity_type || "Unknown",
    },
    {
      id: 10,
      key: "Identity Number",
      value: caseDetails?.identity_number || "Unknown",
    },
    {
      id: 11,
      key: "Referring Agency",
      value: caseDetails?.referring_agency || "Unknown",
    },
    {
      id: 12,
      key: "Purpose of Assessment",
      value: caseDetails?.purpose_of_assessment || "Unknown",
    },
    // {
    //   id: 1245,
    //   key: "Observation",
    //   value: caseDetails?.dental_observation || "Unknown",
    // },
  ];

  return (
    <div className="d-case_details_container">
      <div className="case_details_body">
        <div className="case_details_header">
          <p>Subject Information</p>
        </div>
        {subjectInformation.map((item, index) => {
          if (item.id === 8 || item.id === 122) {
            return (
              <div
                className="case_details_subItem"
                style={{ borderBottom: "0.5px solid #c5c5c580" }}
              >
                <div className="left_section">
                  <p
                    className="left_section_key"
                    style={{
                      fontSize: 13,
                      // fontFamily: "Poppins-Regular",
                    }}
                  >
                    {item.key}
                  </p>
                </div>
                <div className="right_section">
                  <p className="right_section_value">{item.value}</p>
                </div>
              </div>
            );
          }
          return (
            <div className="case_details_item" key={index}>
              <div className="left_section">
                <p className="left_section_key">{item.key}</p>
              </div>
              <div className="right_section" style={{ textAlign: "right" }}>
                <p className="right_section_value">{item.value}</p>
              </div>
            </div>
          );
        })}
      </div>
      <div className="case_details_body">
        <div className="case_details_header">
          <p>Dental Record Information</p>
        </div>
        <div className="case_details_item">
          <div className="left_section">
            <p className="left_section_key">Radiograph Date</p>
          </div>
          <div className="right_section" style={{ textAlign: "right" }}>
            <p className="right_section_value">
              {caseDetails &&
                formateDateAndTime(caseDetails?.radiograph_date, "DD MMM YYYY")}
            </p>
          </div>
        </div>

        {Array.isArray(caseDetails?.missing_teeth) &&
          caseDetails?.missing_teeth.length > 0 && (
            <div className="case_details_subItem">
              <div className="left_section">
                <p className="left_section_key">Missing Tooth (M-T)</p>
              </div>

              <div className="subitem_iso">
                {caseDetails?.missing_teeth?.map((el, index) => {
                  return (
                    <p className="subitem_iso_value" key={index}>
                      {el}
                      {index !== caseDetails.missing_teeth.length - 1 && ", "}
                    </p>
                  );
                })}
              </div>
            </div>
          )}
        {Array.isArray(caseDetails?.restored_teeth) &&
          caseDetails?.restored_teeth.length > 0 && (
            <div className="case_details_subItem">
              <div className="left_section">
                <p className="left_section_key">Restored Teeth (R-T)</p>
              </div>

              <div className="subitem_iso">
                {caseDetails?.restored_teeth?.map((el, index) => {
                  return (
                    <p className="subitem_iso_value" key={index}>
                      {el}
                      {index !== caseDetails.restored_teeth.length - 1 && ", "}
                    </p>
                  );
                })}
              </div>
            </div>
          )}
        {Array.isArray(caseDetails?.present_teeth) &&
          caseDetails?.present_teeth.length > 0 && (
            <div className="case_details_subItem">
              <div className="left_section">
                <p className="left_section_key">Present Teeth (P-T)</p>
              </div>

              <div className="subitem_iso">
                {caseDetails?.present_teeth?.map((el, index) => {
                  return (
                    <p className="subitem_iso_value" key={index}>
                      {el}
                      {index !== caseDetails.present_teeth.length - 1 && ", "}
                    </p>
                  );
                })}
              </div>
            </div>
          )}
        {Array.isArray(caseDetails?.decayed_teeth) &&
          caseDetails?.decayed_teeth.length > 0 && (
            <div className="case_details_subItem">
              <div className="left_section">
                <p className="left_section_key">Decayed Teeth (D-T)</p>
              </div>
              <div className="subitem_iso">
                {caseDetails?.decayed_teeth?.map((el, index) => {
                  return (
                    <p className="subitem_iso_value" key={index}>
                      {el}
                      {index !== caseDetails.decayed_teeth.length - 1 && ", "}
                    </p>
                  );
                })}
              </div>
            </div>
          )}
        {caseDetails?.dental_observation.length > 0 && (
          <div className="case_details_subItem">
            <div className="left_section">
              <p className="left_section_key">Observation</p>
            </div>
            <div className="right_section">
              <p className="right_section_value">
                {caseDetails && caseDetails?.dental_observation}
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CaseReport;
